<template>
  <div
    class="html_playerInfor"
    ref="html_playerInfor"
    v-if="datas.objectInfo && datas.objectInfo.length > 0"
  >
    <div
      class="main"
      :class="[
        datas.objectInfo && datas.objectInfo.length === 2 ? 'doublePlayer' : '',
      ]"
    >
      <div
        class="singlePlayer"
        v-for="(singleItem, itemIndex) in datas.objectInfo"
        :key="itemIndex"
      >
        <div class="left-box">
          <AbPlayerImg
            v-for="item in singleItem.playerInfos"
            :key="item.playerId"
            :playerImg="item.profilePicture"
            :playerNum="item.shirtNumber"
            :playerName="`${item.playerName} ${
              item.position ? '(' + item.position + ')' : ''
            }`"
            :countryImg="singleItem.teamLogo"
            :countryName="singleItem.teamName"
            :countryLogoSize="countryLogoSize"
          ></AbPlayerImg>
        </div>
        <div
          class="right-box"
          v-if="datas.statisticsModels && datas.statisticsModels.length > 0"
        >
          <div
            class="items"
            v-for="item in datas.statisticsModels"
            :key="item.statisticalEn"
            v-text="
              _valFormatHandler(
                tableData[item.statisticalEn],
                item.name,
                item.suffix
              )
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 球员信息
// import AbPlayerImg from '../components/PlayerImg'
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_playerInfor',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    AbPlayerImg,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return ['1.666vw', '1.666vw']
      } else {
        return ['2.498vw', '1.666vw']
      }
    },
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList[0]
        : {}
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_playerInfor {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);
    &.doublePlayer {
      .singlePlayer {
        &:first-child {
          flex-direction: row-reverse;
          .right-box {
            margin: 0 0.278vw 0 0;
          }
        }
        .right-box {
          margin: 0 0 0 0.278vw;
        }
      }
    }
    .singlePlayer {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }
    .left-box {
      font-size: 0.972vw;
    }
    .right-box {
      margin: 0 0 0 0.694vw;
      height: auto;
      max-height: 16.25vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      overflow: auto;
      .items {
        width: 100%;
        line-height: 1.388vw;
        padding: 0.11vw 1.11vw;
        color: var(--mixtmt_greyColor_main);
        &:nth-child(2n-1) {
          background-color: var(--mixtmt_subColor_main05);
        }
      }
    }
  }
  .ptb4 {
    padding: 0.278vw 0;
  }
}
</style>
